import { render, staticRenderFns } from "./SectionManager.vue?vue&type=template&id=0bb00db7&scoped=true&"
import script from "./SectionManager.vue?vue&type=script&lang=js&"
export * from "./SectionManager.vue?vue&type=script&lang=js&"
import style0 from "./SectionManager.vue?vue&type=style&index=0&id=0bb00db7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb00db7",
  null
  
)

export default component.exports